import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/common/Reveal";
import SectionLabel from "@/components/common/SectionLabel";
import client from "@/lib/api";

export default function BlogPreview() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    client.get("/blog", { params: { limit: 3 } }).then(({ data }) => setPosts(data)).catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <section data-testid="blog-section" className="bg-white py-24 md:py-32">
      <div className="container-gema">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Reveal>
              <SectionLabel index="07" dark={false}>Blog</SectionLabel>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="heading-lg text-black mt-6 max-w-2xl">Noticias y contenido de interés</h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <Link to="/blog" data-testid="blog-view-all" className="btn-outline-dark">Ver Blog</Link>
          </Reveal>
        </div>

        <RevealGroup className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
          {posts.map((p) => (
            <RevealItem key={p.id}>
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block">
                <div className="relative overflow-hidden border border-black/10 h-[240px]">
                  <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
                  <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.2em] text-white bg-gema-red px-3 py-1">{p.category}</span>
                </div>
                <div className="flex items-center gap-3 mt-5 text-black/40 text-xs font-mono uppercase tracking-wider">
                  <Clock className="h-3 w-3" /> {p.read_time}
                </div>
                <h3 className="font-heading font-bold text-lg text-black mt-3 leading-snug group-hover:text-gema-red transition-colors duration-300">{p.title}</h3>
                <p className="text-black/50 text-sm mt-3 leading-relaxed line-clamp-3">{p.excerpt}</p>
                <span className="inline-flex items-center gap-2 mt-4 text-gema-red font-heading text-sm font-bold uppercase tracking-wider">
                  Leer más <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </Link>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
